<!-- Bulk Actions Bar -->
<div
  class="tw-fixed tw-bottom-[12.5px] md:!tw-left-[5%] tw-z-[5] tw-flex tw-justify-center tw-w-full tw-h-14"
  id="batch-operations-container"
  [shown]="selectedCount > 0"
>
  <div
    class="tw-flex tw-items-center tw-gap-2.5 tw-py-[5px] tw-pl-2.5 tw-pr-[5px] tw-text-white tw-rounded-full tw-shadow-lg"
    [class.tw-bg-gray-800]="withinSelectionLimit"
    [class.tw-bg-red-600]="!withinSelectionLimit"
  >
    <span
      class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-px-[5px] tw-rounded-full tw-text-white tw-text-[12.5px] tw-font-semibold"
      [class.tw-bg-gray-600]="withinSelectionLimit"
      [class.tw-bg-red-800]="!withinSelectionLimit"
    >
      {{ selectedCount }}
    </span>
    <span [class]="messageClasses">{{ messageText }}</span>
    @if (withinSelectionLimit) {
      <button
        rv-button
        size="small"
        class="tw-min-w-[120px]"
        (click)="startSharing.emit()"
      >
        Start Sharing
      </button>
    }
    <button
      mat-icon-button
      aria-label="Clear selection"
      [class]="clearButtonClass"
      (click)="clearSelection.emit()"
    >
      <mat-icon svgIcon="close" class="tw-w-[18px] tw-h-[18px]" />
    </button>
  </div>
</div>
